// extracted by mini-css-extract-plugin
export default {"blankFrame":"BlankFrame_blankFrame__z8Xyg"};